const cities = [
  { name: 'Richmond', county: 'City of Richmond', desc: 'A thriving independent restaurant, cafe, and bar scene with a growing small business community' },
  { name: 'Henrico County', county: 'Greater Richmond', desc: 'Suburban growth corridor with strong demand for trades and local service businesses' },
  { name: 'Chesterfield County', county: 'Greater Richmond', desc: 'Fast-growing county with expanding restaurants, contractors, and nonprofit organizations' },
];

export default function AreasServed() {
  return (
    <section id="areas" className="bg-primary-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <p className="text-accent-400 text-sm font-semibold tracking-widest uppercase mb-3">
                Local by Design
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-6">
                Serving the Richmond Area
                <span className="italic text-accent-400"> Where You Operate</span>
              </h2>
              <p className="text-background-300 text-base md:text-lg leading-relaxed mb-8">
                We focus on a tight geographic footprint because local context matters.
                We understand the competitive restaurant scene in the city, the growth
                corridors across Henrico, and the expanding trades and small business
                demand throughout Chesterfield.
              </p>
              <div className="flex flex-wrap gap-3 mb-8">
                {['Virtual-First', 'In-Person Available', 'Same-Day Response', 'Local Knowledge'].map(
                  (tag) => (
                    <span
                      key={tag}
                      className="inline-flex items-center gap-1.5 bg-background-50/10 text-background-200 text-xs font-medium px-3 py-1.5 rounded-full"
                    >
                      <i className="ri-check-line text-accent-400" />
                      {tag}
                    </span>
                  )
                )}
              </div>
              <p className="text-background-400 text-sm">
                Virtual-first service with selective in-person meetings available in
                Richmond, Henrico, and Chesterfield.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              {cities.map((city) => (
                <div
                  key={city.name}
                  className="bg-background-50/5 backdrop-blur-sm border border-background-50/10 rounded-xl p-5 hover:bg-background-50/10 transition-colors"
                >
                  <div className="flex items-center gap-2 mb-2">
                    <i className="ri-map-pin-line text-accent-400 text-sm" />
                    <h3 className="font-heading text-base text-background-50 font-semibold">
                      {city.name}
                    </h3>
                  </div>
                  <p className="text-accent-300 text-xs font-medium uppercase tracking-wider mb-1">
                    {city.county}
                  </p>
                  <p className="text-background-400 text-sm leading-relaxed">{city.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}